@if (!isClientAdminView) {
  @if (showHasImportConfigurationFilter) {
    <div class="d-flex align-items-center mb-2">
      <ejs-checkbox [label]="'i18n.domain.import-configuration.filter.has-import-configuration-label' | translate"
                    [(checked)]="hasImportConfigurationFilter"
                    (change)="onHasImportConfigurationChange($event.checked)">
      </ejs-checkbox>
      <ejs-tooltip [content]="'i18n.domain.import-configuration.filter.has-import-configuration-tooltip' | translate" target="#hasImportConfigTooltipTarget">
        <span id="hasImportConfigTooltipTarget" class="e-icons icon-help detail-icon ms-2"></span>
      </ejs-tooltip>
    </div>
  }
  @if (showHasExportConfigurationFilter) {
    <div class="d-flex align-items-center mb-2">
      <ejs-checkbox [label]="'i18n.domain.export-configuration.filter.has-export-configuration-label' | translate"
                    [(checked)]="hasExportConfigurationFilter"
                    (change)="onHasExportConfigurationChange($event.checked)">
      </ejs-checkbox>
      <ejs-tooltip [content]="'i18n.domain.export-configuration.filter.has-export-configuration-tooltip' | translate" target="#hasExportConfigTooltipTarget">
        <span id="hasExportConfigTooltipTarget" class="e-icons icon-help detail-icon ms-2"></span>
      </ejs-tooltip>
    </div>
  }
  <app-autocomplete [getDataFunction]="searchClientData.bind(this)"
                    [fields]="fields"
                    [(value)]="selectedClientId"
                    [placeholder]="placeholder"
                    [enabled]="!isDisabled"
                    [isFormComponent]="isFormComponent"
                    (touched)="onTouched()">
  </app-autocomplete>
}
@if (isClientAdminView) {
  <span>{{selectedClientName}}</span>
}
